import React from 'react';
import { Modal } from 'react-bootstrap';

export default (props) => (
  <Modal
    className="copyright-circumstances-modal"
    show={props.open}
    onHide={() => props.onClose()}
  >
    <Modal.Body>
      <div>
        <p>
          You may register multiple works during this session if the claimants,
          authors, their roles, and the release information are identical across
          all of the titles. If not, you will need to create separate
          applications of each work.
        </p>
        <button onClick={props.onClose}>Close</button>
      </div>
    </Modal.Body>
  </Modal>
);



// WEBPACK FOOTER //
// src/components/Copyright/CircumstancesPopup.jsx